module.exports = __webpack_public_path__ + "static/media/rvceLogo.00872972.png";